  $(document).ready(function() {
    $('.index_brand_slider').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              arrows: false,
              dots: false, 
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
            }
          }
        ]
    }); 
    $('.index_customer_care_slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true, 
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            }
          }
        ]
    }); 
    $('.product_brand_slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false,
    }); 
    $('.index-review-slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    }); 
    
//     $('.about-columns-images-slider').slick({
//       infinite: false,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: true,
//     }); 
    
      var payment_icon = setInterval(function(){
      if($(".afterpay-paragraph").length > 0){
        jQuery(".afterpay-text1").text("or 4 instalments of ");
    	jQuery(".afterpay-text2").text(" with ");
        clearInterval(payment_icon);
      }
    }, 100);
    
       $(document).on("click",".logo-box",function(e) {
      //$(this).siblings().toggle();
      var tab_id = $(this).attr('data-tab');
       $('.logo-box').removeClass('active');
      $('.index_brand_slider_content .logo-sub-text').removeClass('active');

      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    });
    
    $(document).on("click",".bundle-img-item",function(e) {
      //$(this).siblings().toggle();
      var tab_id = $(this).attr('data-id');
       $('.bundle-img-item').removeClass('active');
      $('.bundle-product-wrap').removeClass('active');

      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    });
    
    $(function() {
		 $(".bundle_submit1").click(function(e) {
        	e.preventDefault();
           	//var frmAction = $('.form_bundle_product1').serialize();
           	var bundle_product = $('input[name=bundle_id1]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
      
      	$(".bundle_submit2").click(function(e) {
        	e.preventDefault();
           	//var frmAction2 = $('.form_bundle_product2').serialize();
           	var bundle_product = $('input[name=bundle_id2]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
      
      	$(".bundle_submit3").click(function(e) {
        	e.preventDefault();
           	//var frmAction3 = $('.form_bundle_product3').serialize();
           	var bundle_product = $('input[name=bundle_id3]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
    });

      $('.index-customer-care-team .text-column__button-row .text-column__button').click(function(){
        $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).offset().top - 140
        }, 800);
        return false;
      });

    var payment_icon = setInterval(function(){
      
      if($(".afterpay-paragraph").length > 0){
        
        jQuery(".afterpay-text1").text("or 4 instalments of ");
    	jQuery(".afterpay-text2").text(" with ");
        
        clearInterval(payment_icon);

      }

    }, 100);


        $('.toggle-item').click(function(e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.next().hasClass('inner-show')) {
            $this.removeClass('active');
            $this.next().removeClass('inner-show');
            $this.next().slideUp(350); 
        } else { 
            $this.parent().parent().find('li .toggle-item ').removeClass('active');
            $this.toggleClass('active');
            $this.parent().parent().find('li .inner').removeClass('inner-show');
            $this.parent().parent().find('li .inner').slideUp(350); 
            $this.next().toggleClass('inner-show');
            $this.next().slideToggle(350); 
        } 
    });
    
  });

function BannerSliderInstance() {
    let $bannerSlider = $('.banner_slider_slick');
    let $imageTextSlider = $('.image_text_slick');

    // Check if slick is initialized and destroy before reinitializing
    if ($bannerSlider.hasClass('slick-initialized')) {
        $bannerSlider.slick('unslick');
    }

    $bannerSlider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        prevArrow: '<div class="slick-arrow-custom slick-prev-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></span></div>',
        nextArrow: '<div class="slick-arrow-custom slick-next-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></span></div>',
        responsive: [
            {
                breakpoint: 5000,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    autoplay: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    // Initialize Image Text Slider if not already initialized
    if (!$imageTextSlider.hasClass('slick-initialized')) {
        $imageTextSlider.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<div class="slick-arrow-custom slick-prev-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></span></div>',
            nextArrow: '<div class="slick-arrow-custom slick-next-custom"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></span></div>',
        });
    }
}

// Call the function once on page load
BannerSliderInstance();

// Debounce function to limit the frequency of resize events
function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

// Reinitialize slider on window resize with debounce
$(window).on('resize', debounce(function () {
    BannerSliderInstance();
    console.log("BannerSliderInstance reinitialized on resize.");
}, 300));

// CD Arshit
$(document).on('click', '.klaviyo-form-Y63Q8L button.needsclick.go331100717', function(){
  window._fbq.push('track', 'Lead');
});


$('.carousel').each(function () {
  $(this).on('changed.owl.carousel', function(e) {
    const items    = e.item.count;
    const current  = e.item.index;
    const perPage  = e.page.size;

    $(this).closest('.collection-listing').find('.prev').toggleClass('disabled', current === 0);
    $(this).closest('.collection-listing').find('.next').toggleClass('disabled', current >= items - perPage);
  })
});

// document.addEventListener('rebuy.ready', (event) => {
//   const widget = event.detail.widget;
//   const carouselWidgetId = 177883;

//   if (widget.id == carouselWidgetId) {
//     const interval = setInterval(function() {
//       const splideEl = document.querySelector(`[data-rebuy-id="${widget.id}"] .splide.is-initialized`);

//       log
      
//       if (splideEl) {
//         clearInterval(interval);
//         const splide = new Splide(splideEl);

//         splide.destroy();
//         console.log('splide destroyed');
        
//         splide.options = {
//           rewind: false,
//           type: 'slide',
//           perMove: 1
//         };
//         splide.mount();

//         const prevBtn = splideEl.querySelector('.splide__arrow--prev');
//         const nextBtn = splideEl.querySelector('.splide__arrow--next');

//         function updateButtons(index) {
//           const total   = splide.length;
//           const perPage = splide.options.perPage;

//           prevBtn.classList.toggle('disabled', index === 0);
//           nextBtn.classList.toggle('disabled', index >= total - perPage);
//         }

//         splide.on('moved', function(newIndex) {
//           updateButtons(newIndex);
//         });

//         updateButtons(splide.index);
//       }
//     }, 100);
//   }
// });

/* Mobile drawer: second-level items with children open as slide-in panels */
(function () {
  var OPEN = 'navigation__item--open';

  // Title change: hide with the theme's own hidden state, swap the text, then show again,
  // so the theme's .mobile-nav-title transition (styles.css.liquid) plays exactly as for the first level
  function setTitle(title, text) {
    title.classList.add('mobile-nav-title--reset');
    title.textContent = text;
    void title.offsetWidth; // force reflow so removing the class animates
    title.classList.remove('mobile-nav-title--reset');
  }

  function closeSlide(drawer) {
    var open = drawer.querySelectorAll('.navigation__item--slide.' + OPEN);
    if (!open.length) return false;
    open.forEach(function (li) { li.classList.remove(OPEN); });
    var title = drawer.querySelector('.mobile-nav-title');
    if (title && drawer.getAttribute('data-prev-title')) {
      setTitle(title, drawer.getAttribute('data-prev-title'));
    }
    drawer.removeAttribute('data-prev-title');
    return true;
  }

  // open: the theme adds the open class; we only swap the header title.
  // jQuery handler, because the theme triggers the toggle via $.trigger (no native event).
  $(document).on('click', '.navigation__item--slide > .navigation__children-toggle', function () {
    var drawer = this.closest('.mobile-navigation-drawer');
    var panel = this.parentNode.querySelector('.slide-panel');
    var title = drawer && drawer.querySelector('.mobile-nav-title');
    if (!title || !panel) return;
    if (!drawer.getAttribute('data-prev-title')) drawer.setAttribute('data-prev-title', title.textContent);
    setTitle(title, panel.getAttribute('data-slide-title'));
  });

  // back arrow: close the panel first (capture runs before the theme's handler)
  document.addEventListener('click', function (e) {
    var back = e.target.closest && e.target.closest('.mobile-nav-back');
    if (!back) return;
    var drawer = back.closest('.mobile-navigation-drawer');
    if (drawer && closeSlide(drawer)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // closing the drawer resets any open panel
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.mobile-nav-toggle'))) return;
    document.querySelectorAll('.mobile-navigation-drawer').forEach(closeSlide);
  });
})();

/* Badge alignment: in each menu list, every badge starts at the same x, set by the longest title that has a badge */
(function () {
  if (!window.ResizeObserver) return;
  var LISTS = 'ul.navigation__tier-2, ul.navigation__tier-3, ul.rich-links__list, .mobile-navigation-drawer ul.navigation__tier-1';
  var seen = new WeakSet();

  function hasTag(label) {
    var box = label.closest('.menu-title--tagged, .rich-links__heading');
    return !!(box && box.querySelector('.menu-tag'));
  }

  function sync(list) {
    var max = 0;
    list.querySelectorAll('.menu-title__label').forEach(function (l) {
      // own items only: nested submenus are separate lists with their own column
      if (l.closest(LISTS) === list && hasTag(l)) max = Math.max(max, l.getBoundingClientRect().width);
    });
    list.style.setProperty('--tag-title-w', max ? Math.ceil(max) + 'px' : '0px');
  }

  // labels report a size when they become visible (drawer / dropdown opens), so hidden lists sync on open
  var observer = new ResizeObserver(function (entries) {
    var lists = [];
    entries.forEach(function (en) {
      var list = en.target.closest(LISTS);
      if (list && lists.indexOf(list) < 0) lists.push(list);
    });
    lists.forEach(sync);
  });

  function init() {
    // every list gets its own value, so nested lists never inherit a parent's width
    document.querySelectorAll(LISTS).forEach(function (list) {
      if (!list.style.getPropertyValue('--tag-title-w')) list.style.setProperty('--tag-title-w', '0px');
    });
    document.querySelectorAll('.menu-title__label').forEach(function (l) {
      if (!seen.has(l) && l.closest(LISTS) && hasTag(l)) {
        seen.add(l);
        observer.observe(l);
      }
    });
  }

  function reset() {
    document.querySelectorAll(LISTS).forEach(function (list) { list.style.setProperty('--tag-title-w', '0px'); });
    init();
    document.querySelectorAll(LISTS).forEach(sync);
  }

  $(document).ready(function () {
    init();
    setTimeout(init, 800); // the theme clones the mobile drawer after load
    setTimeout(init, 2500);
  });
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(reset, 200); });
})();
